export const BASE_URL = "https://wink.codes:49150/api";
export const CONVERT_URL = "https://api.coingecko.com/api/v3/coins/";
export const CONTRACT_ADDRESS = "0xf76D51b6464d932A7d4f89841a33c759C6e5D5A3";
export const COIN_GECKO_CAP = "https://www.coingecko.com/";
export const TX_CHECK = "https://goerli.etherscan.io/tx/";
export const INFURA_WSS_NODE_URL = "wss://goerli.infura.io/ws/v3/412b1e53694f4cf0aece3f301099185c";
